import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryShowcase from './components/CategoryShowcase';
import FeaturedProducts from './components/FeaturedProducts';
import BrandFeatures from './components/BrandFeatures';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import ArticlePreview from './components/ArticlePreview';
import CTABanner from './components/CTABanner';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://rejiujiu.com/#organization',
      name: '热久久',
      url: 'https://rejiujiu.com',
      description: '专为寒冷环境打造的持久保暖品牌，先进发热技术与持久恒温性能',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-9999',
        contactType: 'customer service',
        availableLanguage: 'Chinese',
      },
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'CN',
        addressLocality: '上海',
      },
    },
    {
      '@type': 'WebSite',
      '@id': 'https://rejiujiu.com/#website',
      url: 'https://rejiujiu.com',
      name: '热久久',
      inLanguage: 'zh-CN',
      publisher: { '@id': 'https://rejiujiu.com/#organization' },
    },
    {
      '@type': 'WebPage',
      '@id': 'https://rejiujiu.com/#webpage',
      url: 'https://rejiujiu.com',
      name: '热久久官网 - 持久保暖解决方案',
      isPartOf: { '@id': 'https://rejiujiu.com/#website' },
      about: { '@id': 'https://rejiujiu.com/#organization' },
      primaryImageOfPage: {
        '@type': 'ImageObject',
        url: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20winter%20scene%20with%20soft%20golden%20amber%20light%20glowing%20through%20frosted%20window%2C%20artistic%20abstract%20warmth%20concept%2C%20gentle%20gradient%20from%20warm%20cream%20to%20deep%20amber%2C%20minimalist%20elegant%20atmosphere%2C%20soft%20bokeh%20effect%2C%20warm%20toned%20artistic%20photography%2C%20peaceful%20winter%20comfort%20aesthetic&width=1920&height=900&seq=hero-bg-rejiujiu&orientation=landscape',
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '热久久保暖贴可以持续发热多久？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '热久久经典保暖贴可持续发热12小时，平均温度53°C；强效保暖贴可持续发热18小时，平均温度58°C。',
          },
        },
        {
          '@type': 'Question',
          name: '保暖贴可以贴身使用吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '不可以。保暖贴必须贴在内衣外侧，通过衣物隔离。直接接触皮肤可能导致低温烫伤。',
          },
        },
        {
          '@type': 'Question',
          name: '如何选择适合自己的保暖产品？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '日常通勤推荐经典保暖贴+便携暖手宝组合；户外工作推荐强效保暖贴+加热马甲+加热鞋垫全套方案。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <CategoryShowcase />
          <FeaturedProducts />
          <BrandFeatures />
          <Testimonials />
          <CTABanner />
          <ArticlePreview />
          <FAQ />
        </main>
        <Footer />
      </div>
    </>
  );
}